import { render } from "./NewsFeedNavigationProfile.vue?vue&type=template&id=739be36e"
import script from "./NewsFeedNavigationProfile.vue?vue&type=script&lang=js"
export * from "./NewsFeedNavigationProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__